module.exports = __webpack_public_path__ + "static/media/gallery-grey2.5543b63a.jpg";